var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAssign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27530",
    "data-name": "Group 27530",
    transform: "translate(.001 -.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46738",
    "data-name": "Path 46738",
    d: "M6.4,7.707A3.479,3.479,0,0,0,9,6.578a3.819,3.819,0,0,0,1.08-2.725A3.821,3.821,0,0,0,9,1.129,3.562,3.562,0,0,0,3.966.964q-.086.079-.165.165A3.822,3.822,0,0,0,2.723,3.854,3.82,3.82,0,0,0,3.8,6.578,3.482,3.482,0,0,0,6.4,7.707Z",
    transform: "translate(-.039)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(-.001 7.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_47683",
    "data-name": "Path 47683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29043",
    "data-name": "Group 29043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48329",
    "data-name": "Path 48329",
    d: "M7.009,14.7a1.512,1.512,0,0,1,0-2.236,1.469,1.469,0,0,1,2.1.141l2.016,1.969,1.859-1.814c-.005-.154,0-.31-.014-.461a9.831,9.831,0,0,0-.127-1.011,8.245,8.245,0,0,0-.242-1.016,5.092,5.092,0,0,0-.407-.948,3.572,3.572,0,0,0-.614-.821,2.707,2.707,0,0,0-.881-.569,2.972,2.972,0,0,0-1.126-.209,1.124,1.124,0,0,0-.61.266c-.183.122-.4.264-.635.421a3.582,3.582,0,0,1-.822.372,3.119,3.119,0,0,1-2.011,0,3.574,3.574,0,0,1-.819-.376c-.237-.155-.451-.3-.636-.421a1.127,1.127,0,0,0-.61-.266A2.967,2.967,0,0,0,2.3,7.934a2.691,2.691,0,0,0-.881.569,3.572,3.572,0,0,0-.614.821,5.092,5.092,0,0,0-.407.948A8.245,8.245,0,0,0,.16,11.288,9.831,9.831,0,0,0,.033,12.3c-.02.306-.031.624-.031.945a2.7,2.7,0,0,0,.768,2.01A2.72,2.72,0,0,0,2.75,16H8.3Z",
    transform: "translate(.001 -7.725)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48330",
    "data-name": "Path 48330",
    d: "M11.03,17.444a.71.71,0,0,0,.985,0L18.2,11.189a.7.7,0,0,0-.005-.954.689.689,0,0,0-.487-.218.781.781,0,0,0-.5.189l-5.689,5.759L8.844,13.33a.666.666,0,0,0-.455-.173.7.7,0,0,0-.518,1.169Z",
    transform: "translate(-.388 -7.977)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAssign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_assign.a185e04a6cadfb45819937dc37772c93.svg";